export default __webpack_public_path__ + "static/media/cs-a018-8.bea85c36.svg";